import Vue from 'vue'
import App from './App'
import router from './router/permission'
import ElementUI from 'element-ui';
import Avue from '@smallwei/avue';
import axios from './axios/index'
import VueAxios from 'vue-axios'
import 'element-ui/lib/theme-chalk/index.css';
import '@smallwei/avue/lib/index.css';
import store from './store/index.js'
import * as filters from '@/filter/index'
import * as util from './utils/util'
import * as u from './utils/util'
import * as config from './utils/config'
import * as c from './utils/config'
import {HttpService}  from './utils/HttpService'
import '@/css/core.css';
import hasPermission from '@/utils/hasPermission'
import { permissionMixin } from '@/mixins/permissionMixin'
import WatermarkPlugin from '@/plugins/local-watermark-plugin'
import Ellipsis from '@/components/ellipsis'

import Antd, { message } from 'ant-design-vue/lib'
import 'ant-design-vue/dist/antd.css'
import Storage from 'vue-ls'

import '@/assets/less/common.less'

Vue.prototype.$message = message
Vue.prototype.$isNotEmpty = function (obj) {
  return obj !== undefined && obj !== null && obj !== '' && obj !== 'null'
}

Vue.prototype.$getDefalut = function (obj, key, df) {
  return obj === undefined || key === undefined || !this.$isNotEmpty(obj[key])
    ? df
    : obj[key]
}
Vue.prototype.$deepCopy = function (obj) {
  return JSON.parse(JSON.stringify(obj))
}
/*全局过滤器*/
Object.keys(filters).forEach(key=>{
  Vue.filter(key,filters[key])
})

// 挂载到Vue实力上，全局可通过this.$store进行调用
Vue.prototype.$store = store
//将工具类挂载在vue上
Vue.prototype.$util = util
Vue.prototype.$config = config
Vue.prototype.$HttpService = new HttpService();
Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(Avue);
Vue.use(VueAxios, axios)
Vue.prototype.$axios = axios
window.axios = axios
Vue.use(Antd)

Vue.use(hasPermission) 
Vue.mixin(permissionMixin)
Vue.use(WatermarkPlugin)
Vue.use(Storage, config.storageOptions)

Vue.mixin({
  // 全局filter
  filters: {
      splitFirstFilter(str) {
          // 取名字的第一个字
          if (!str) return str
          return str.substr(0, 1)
      },
      // fullAvatar(avatar) {
      //     if (!avatar) return
      //     //判断是否包含https
      //     if (avatar.substr(0, 4) === 'http') {
      //         return avatar
      //     } else {
      //         return window._CONFIG['domianURL'] + '/sys/common/view/' + avatar
      //     }
      // }
  }, 
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  data() {
    return {
       watermarkTimer: null // 水印定时器
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.user.isLoggedIn
    }
  },
  watch: {
     
    isLoggedIn(newVal) {
      if (newVal) {
        // 登录时更新水印并启动定时器
        this.updateWatermark()
        this.startWatermarkTimer()
      } else {
        // 登出时清除水印并停止定时器
        this.$watermark.clear()
        this.stopWatermarkTimer()
      }
    }
  },
  mounted() {
    // 根据登录状态设置默认全局水印
    if (this.$store.state.user.isLoggedIn) {
      this.updateWatermark()
      this.startWatermarkTimer()
    } 
  },
  beforeDestroy() {
    // 组件销毁前清理定时器
    this.stopWatermarkTimer()
  },
  methods: {
    // 更新水印内容
    updateWatermark() {
      try {
        const userInfo = u.getSession(c.sessionKey.USER_INFO)
          // const date = this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
        const date = this.formatDate(new Date(), 'yyyy-MM-dd hh:mm')
        const fullName = userInfo && userInfo.name ? userInfo.name : ''
        let phone = userInfo && userInfo.phone ? userInfo.phone : ''
        phone = phone.slice(0, 3) + '****' + phone.slice(7)
        const content = [`${fullName}`, date]
        if (this.$store.state.user.isLoggedIn) {
          this.$watermark.apply({ content, color: 'rgba(0,0,0,0.52)', fontSize: 16, rotate: -22 })
        } else {
          this.$watermark.clear()
        }
      } catch (e) {
        console.error('更新水印失败:', e)
      }
    },
    // 格式化日期
    formatDate(date, format) {
      const o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds(),
        'q+': Math.floor((date.getMonth() + 3) / 3),
        'S': date.getMilliseconds()
      }
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
        }
      }
      return format
    },
    // 启动水印定时器
    startWatermarkTimer() {
      // 清除现有定时器
      if (this.watermarkTimer) {
        clearInterval(this.watermarkTimer)
      }
      // 设置1分钟定时器
      this.watermarkTimer = setInterval(() => {
        this.updateWatermark()
      }, 60000) // 60秒 = 60000毫秒
    },
    // 停止水印定时器
    stopWatermarkTimer() {
      if (this.watermarkTimer) {
        clearInterval(this.watermarkTimer)
        this.watermarkTimer = null
      }
    }
  },
})
